/**
 * 收费处路由
 */
const basePath = 'live-nurse'
var liveNurseRoutes = [
  {
    path: `${basePath}/receive-query`,
    name: `${basePath}/receive-query`,
    meta: {
      title: '入院处理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/receive-query.vue'], resolve)
  },
  {
    path: `${basePath}/receive-form/:id`,
    name: `${basePath}/receive-form`,
    meta: {
      title: '接收入院',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '入院处理',
          path: `/default/${basePath}/receive-query`
        }
      }
    },
    component: resolve => require(['../views/page/live-nurse/receive-form.vue'], resolve)
  },
  {
    path: `${basePath}/area-patient-list`,
    name: `${basePath}/area-patient-list`,
    meta: {
      title: '病区病人',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/area-patient-list.vue'], resolve)
  },
  {
    path: `${basePath}/leave-patient-list`,
    name: `${basePath}/leave-patient-list`,
    meta: {
      title: '出院病人',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/leave-hospital.vue'], resolve)
  },
  {
    path: `${basePath}/bb-feiyong-setting`,
    name: `${basePath}/bb-feiyong-setting`,
    meta: {
      title: '费用配置',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/bb-feiyong-setting.vue'], resolve)
  },
  {
    path: `${basePath}/refund-management`,
    name: `${basePath}/refund-management`,
    meta: {
      title: '退费管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/refund-management'], resolve)
  },
  {
    path: `${basePath}/drug-dispensing`,
    name: `${basePath}/drug-dispensing`,
    meta: {
      title: '摆药申请',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/drug-dispensing'], resolve)
  },
  {
    path: `${basePath}/advices-check`,
    name: `${basePath}/advices-check`,
    meta: {
      title: '病区核对',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/advices-check'], resolve)
  },
  {
    path: `${basePath}/advices-execute`,
    name: `${basePath}/advices-execute`,
    meta: {
      title: '病区执行',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/advices-execute'], resolve)
  },
  {
    path: `${basePath}/advice-application`,
    name: `${basePath}/advice-application`,
    meta: {
      title: '医技单打印',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/advice-application.vue'], resolve)
  },
  {
    path: `${basePath}/advice-execute`,
    name: `${basePath}/advice-execute`,
    meta: {
      title: '执行单打印',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/advice-execute.vue'], resolve)
  },
  {
    path: `${basePath}/advice-execute-setting`,
    name: `${basePath}/advice-execute-setting`,
    meta: {
      title: '执行单打印设置',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/advice-execute-setting.vue'], resolve)
  },
  {
    path: `${basePath}/turn-manager`,
    name: `${basePath}/turn-manager`,
    meta: {
      title: '入科申请',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/live-nurse/turn-manager.vue'], resolve)
  }
]

function childRoutes (r, nav) {
  return [
    {
      path: 'advice-check',
      name: `${r}-advice-check`,
      meta: {
        title: '住院管理-医嘱查对',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-check.vue'], resolve)
    },
    {
      path: 'advice-tabs',
      name: `${r}-advice-tabs`,
      meta: {
        title: '住院管理-医嘱处理',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-tabs.vue'], resolve)
    },
    {
      path: 'advice-query',
      name: `${r}-advice-query`,
      meta: {
        title: '住院管理-医嘱查询',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-query.vue'], resolve)
    },
    {
      path: 'advice-application',
      name: `${r}-advice-application`,
      meta: {
        title: '住院管理-申请单打印',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-application.vue'], resolve)
    },
    {
      path: 'advice-execute',
      name: `${r}-advice-execute`,
      meta: {
        title: '住院管理-执行单打印',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-execute.vue'], resolve)
    },
    {
      path: 'advice-cancelFee',
      name: `${r}-advice-cancelFee`,
      meta: {
        title: '住院管理-退费管理',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/advice-cancelFee.vue'], resolve)
    },
    // {
    //   path: 'tab-nurse-advice',
    //   name: `${areaPatientBaseName}-tab-nurse-advice`,
    //   meta: {
    //     title: '住院管理-日常费录入',
    //     requiresAuth: true,
    //     nav: areaPatientMetaNav
    //   },
    //   component: resolve => require(['../views/page/live-nurse/components/tab-nurse-advice.vue'], resolve)
    // },
    {
      path: 'daily-fee',
      name: `${r}-daily-fee`,
      meta: {
        title: '住院管理-每日费用',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/daily-fee.vue'], resolve)
    },
    {
      path: 'fee-summary',
      name: `${r}-fee-summary`,
      meta: {
        title: '住院管理-费用汇总',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/fee-summary.vue'], resolve)
    },
    {
      path: 'change-bed-list',
      name: `${r}-change-bed-list`,
      meta: {
        title: '住院管理-转床处理',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/change-bed-list.vue'], resolve)
    },
    {
      path: 'tab-discharged',
      name: `${r}-tab-discharged`,
      meta: {
        title: '住院管理-转床处理',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/tab-discharged.vue'], resolve)
    },
    {
      path: 'tab-emr',
      name: `${r}-emr`,
      meta: {
        title: '住院管理-电子病历',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/tab-emr.vue'], resolve)
    },
    {
      path: 'fee-check',
      name: `${r}-fee-check`,
      meta: {
        title: '住院管理-费用核对',
        requiresAuth: true,
        nav
      },
      component: resolve => require(['../views/page/live-nurse/components/fee-check.vue'], resolve)
    }
  ]
}

var areaPatientBaseName = 'live-nurse-area-patient-manage'
var areaPatientMetaNav = {
  title: '工作站',
  path: '/default/workplace',
  children: {
    title: '病区病人',
    path: `/default/${basePath}/area-patient-list`
  },
  tab: areaPatientBaseName
}

liveNurseRoutes.push({
  path: `${basePath}/area-patient-manage/:inpatient_record_id/:patient_id`, // create_user inpatient_record_id patient_id
  name: `${basePath}/area-patient-manage`,
  redirect: function (route) {
    let params = route.params
    return `${basePath}/area-patient-manage/${params.inpatient_record_id}/${params.patient_id}` + '/advice-check'
  },
  meta: {
    title: '住院管理',
    requiresAuth: true,
    nav: areaPatientMetaNav
  },
  component: resolve => require(['../views/page/live-nurse/area-patient-manage.vue'], resolve),
  children: childRoutes(areaPatientBaseName, areaPatientMetaNav)
})

var leavePatientBaseName = 'leave-nurse-leave-patient-manage'
var leavePatientMetaNav = {
  title: '工作站',
  path: '/default/workplace',
  children: {
    title: '出院病人',
    path: `/default/${basePath}/leave-patient-list`
  },
  tab: leavePatientBaseName
}

// 出院查询
liveNurseRoutes.push({
  path: `${basePath}/leave-patient-manage/:inpatient_record_id/:patient_id`, // create_user inpatient_record_id patient_id
  name: `${basePath}/leave-patient-manage`,
  redirect: function (route) {
    let params = route.params
    return `${basePath}/leave-patient-manage/${params.inpatient_record_id}/${params.patient_id}` + '/advice-check'
  },
  meta: {
    title: '住院管理',
    requiresAuth: true,
    nav: leavePatientMetaNav
  },
  component: resolve => require(['../views/page/live-nurse/area-patient-manage.vue'], resolve),
  children: childRoutes(leavePatientBaseName, leavePatientMetaNav)
})

export default liveNurseRoutes
